import {
    USER_CHOOSE_CURRENT_FRUI_QPBZ,
} from './constants';
  
export function chooseCurrentFrui_qpbz(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_QPBZ,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_QPBZ:
        return {
          ...state,
          currentFrui_qpbz:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_qpbz.js